import React from "react";
// import "./libraryBox.css";
import { IP } from "../../internalServer";

const OpenLibraryMcq = ({ sQuestion, questionNumber }) => {
  return (
    <div className="mt-3 library_mcq_box">
      <span className="library_mcq_question">
        Q{questionNumber + 1}. {sQuestion?.title}
      </span>

      <div style={{ fontSize: "15px" }}>
        {(sQuestion?.question?.domain?.name ||
          sQuestion?.question?.domain_id?.name) ??
          "-"}{" "}
        |{" "}
        {(sQuestion?.question?.skill?.name ||
          sQuestion?.question?.skill_id?.name) ??
          "-"}{" "}
        |{" "}
        {(sQuestion?.question?.type?.name ||
          sQuestion?.question?.type_id?.name) ??
          "MCQ"}{" "}
        | {sQuestion?.question?.difficulty_level?.name ?? "-"} |{" "}
        {(sQuestion?.question?.book?.name ||
          sQuestion?.question?.book_id?.bookName) ??
          "-"}{" "}
        :{" "}
        {(sQuestion?.question?.chapter?.chapterName ||
          sQuestion?.question?.chapter_id?.chapterName) ??
          "-"}
      </div>

      {/* Show question-level attachments if any */}
      {Array.isArray(sQuestion?.attachments) &&
        sQuestion.attachments.length > 0 && (
          <div className="mt-3 ms-4">
            <div className="d-flex flex-wrap gap-2 mt-2">
              {sQuestion.attachments.map((att, i) => (
                <img
                  key={i}
                  src={`${IP}${att}`} // prefix `/` to match public path if needed
                  alt={`attachment-${i}`}
                  style={{
                    width: "70px",
                    height: "70px",
                    borderRadius: "8px",
                    objectFit: "cover",
                  }}
                />
              ))}
            </div>
          </div>
        )}

      <div className="mt-3 ms-4">
        <ul>
          {sQuestion?.options?.map((option, index) => (
            <li key={index} className="library_mcq_option">
              {option?.key} - {option?.value}
              {/* Show option-level attachment if exists */}
              {option?.attachment && (
                <div className="mt-2">
                  <img
                    src={`${IP}${option.attachment}`}
                    alt={`option-${option.key}`}
                    style={{
                      width: "70px",
                      height: "70px",
                      borderRadius: "8px",
                      objectFit: "cover",
                    }}
                  />
                </div>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default OpenLibraryMcq;
